import { Component, OnInit } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import { Category } from 'src/app/models/category';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  public category: Category;
  public categoryId;
  public loading:boolean=true;
  public categoryForm: FormGroup;
  public imageDataB64:string;
  public fieldLabel:string='Replace Category Image';
  public fieldLabel2:string='Replace Category Image 2';
  public environment=environment;

  constructor(
    private _category: CategoryService,
    private _activeRoute: ActivatedRoute,
    private _notify: NotificationService
  ) {
    this.categoryId = this._activeRoute.snapshot.paramMap.get("categoryId");
    this.categoryForm = new FormGroup({
      name: new FormControl('', [Validators.required])
    });
  }

  public getCategory(catId:number){
    this._category.getCategory(catId).subscribe(res=>{
      this.category=res;
      this.loading=false;
      this.categoryForm.get('name').setValue(this.category.name);
      this.category.media.url=environment.apiEndpoint+'/storage/categories/'+this.category.media.url;
      if(this.category.media2) this.category.media2.url=environment.apiEndpoint+'/storage/categories/'+this.category.media2.url;
    });
  }

  public getImageData(imageData:any){
    this.category.newImageB64=imageData[1];
    this.category.newImageType=imageData[0];
  }

  public getImageData2(imageData:any){
    this.category.newImageB642=imageData[1];
    this.category.newImageType2=imageData[0];
  }

  public updateCategory(){
    this.category.name=this.categoryForm.get('name').value;
    if(this.category.name=='') return this._notify.showMessage('Category must have a title', 'OK');
    this._category.updateCategory(this.category).subscribe(
      res=>{
        this.getCategory(this.categoryId);
        this._notify.showMessage('Category updated.', 'OK');
      }
    );
  }

  ngOnInit() {
    this.getCategory(this.categoryId);
  }

}
